module.exports = __webpack_public_path__ + "img/logo3.aadf1d20.png";